<template>
  <div class="buyone-wrap">
    <app-header />
    <div class="bg">
      <div class="wrap2">
        <div class="banner">
            <img src="../../assets/images/activity/519celebrate/pc-bg-header.jpg" alt="" width="100%">
            <a href="javascript:;" class="btn-buy" @click="goUrl(126)">立即抢购</a>
        </div>
        <section class="mod mod-rule">
            <h2 class="mod-tit tit-hdgz">活动规则</h2>
            <div class="mod-block">
                <img src="../../assets/images/activity/519celebrate/rules-title.png" alt="" width="100%" class="img-rule">
                <p>6月1日移动端<span class="font-yellow">《优选大师》</span>重大升级至<span class="font-org">《优选大师财富版》</span>，产品价格由￥9800元/年调整至16800元/年，9800元/半年。</p>
            </div>
        </section>
        <section class="mod">
            <p class="date-tit"><span>6月1日</span><i>至</i><span>7月31日</span></p>
            <h2 class="mod-tit tit-fldfs">519周年庆福利大放送</h2>
            <div class="mod-block">
                <p>1、PC端<span class="font-org">《大智慧财富版》</span>年卡 + APP端<span class="font-yellow">《优选大师财富版》</span>半年卡打包价仅售￥9800元，买一得二，好产品经得起试用，下单立省￥9800。</p>
                <p>2、<span class="font-yellow">APP端《优选大师财富版》年卡 + </span><span class="font-org">PC端《大智慧财富版》年卡</span>打包价仅售￥16800元，立省￥9800。</p>
                <p>3、买1得18钜惠大礼包产品包含<span class="font-yellow">《优选大师财富版》年卡</span>，仍维持47800元/年不变。</p>
                <p>4、PC端《策略投资终端》用户如购买<span class="font-yellow">APP端《优选大师财富版》年卡</span>赠送价值9800元的《策略投资终端》3个月期限。</p>
                <a href="tel:021-20219999" class="link-text">咨询热点：021-20219999</a>
            </div>
        </section>
        <section class="mod">
            <h2 class="mod-tit tit-yxds">优选大师财富版简介</h2>
            <div class="mod-block">
                <p><span class="font-org">《优选大师财富版》</span>，是一套专为大智慧高净值客户打造的基于金融云的大数据决策辅助系统：尊享大师特权，并通过四大模块：</p>
                <ul class="symbol-list">
                    <li class="dsyp"><div><p>大势研判</p><small>看大势</small></div></li>
                    <li class="rdfx"><div><p>热点风向</p><small>知热点</small></div></li>
                    <li class="yxcl"><div><p>优选策略</p><small>精选股</small></div></li>
                    <li class="yxnc"><div><p>优选内参</p><small>看风口</small></div></li>
                </ul>
                <p>帮助投资者智能定制优选策略，驾驭财富梦想。</p>
            </div>
        </section>
        <section class="mod">
            <h2 class="mod-tit tit-pcdzh">pc大智慧财富版</h2>
            <div class="mod-block mod-block2">
                <span class="block-tag">观大势</span>
                <p>资金动向、大盘先锋<br>大盘趋势分析模型智能分析大盘趋势</p>
                <img src="../../assets/images/activity/519celebrate/pc-img1.jpg" alt="" width="100%">
            </div>
            <div class="mod-block mod-block2">
                <span class="block-tag">知热点</span>
                <p>热点轮动、智能复盘统计<br>明确市场热点板块、个股的轮动方向</p>
                <img src="../../assets/images/activity/519celebrate/pc-img2.jpg" alt="" width="100%">
            </div>
            <div class="mod-block mod-block2">
                <span class="block-tag">股知道</span>
                <p>舆情监控、PEPB温度、ROE<br>价值投资决策也可以如此简单</p>
                <img src="../../assets/images/activity/519celebrate/pc-img3.jpg" alt="" width="100%">
            </div>
            <div class="mod-block mod-block2">
                <span class="block-tag">波段转点</span>
                <p>九转交易(TS时间序列)、波段线、TRT<br>识别市场趋势的潜在转折点。</p>
                <img src="../../assets/images/activity/519celebrate/pc-img4.jpg" alt="" width="100%">
            </div>
            <div class="mod-block mod-block2">
                <span class="block-tag">盘中决策</span>
                <p>主动资金、分时DDX、双突战法<br>实时查看买卖双方主力资金的博弈过程，把握盘中机会。</p>
                <img src="../../assets/images/activity/519celebrate/pc-img5.jpg" alt="" width="100%">
            </div>
            <div class="mod-block mod-block2">
                <span class="block-tag">机构热股</span>
                <p>机构热股、研报中心、机构去哪儿<br>大数据跟踪明星调研机构、研究员优选的热股</p>
                <img src="../../assets/images/activity/519celebrate/pc-img6.jpg" alt="" width="100%">
            </div>
            <div class="mod-block mod-block2">
                <span class="block-tag">10分钟知晓重要新闻</span>
                <p>股票新闻</p><small>去芜存菁，助您挖掘更有价值的财经资讯。</small>
                <img src="../../assets/images/activity/519celebrate/pc-img7.jpg" alt="" width="100%">
                <p>券商晨报</p><small>券商观点早揭秘</small>
                <img src="../../assets/images/activity/519celebrate/pc-img8.jpg" alt="" width="100%">
                <p>大报新闻</p><small>利空？利好！早知道，早布局。</small>
                <img src="../../assets/images/activity/519celebrate/pc-img9.jpg" alt="" width="100%">
            </div>
        </section>
      </div>
    </div>  
  </div>
</template>

<script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
  components: {
    AppHeader,
  },
  data() {
    return {
      token: "",
    };
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  methods: {
    goUrl(key) {
      let routerDate;
      if (this.token) {
        routerDate = this.$router.resolve({
          name: "ClientProduct",
          query: { token: this.token, pid: key },
        });
      } else {
        routerDate = this.$router.resolve({
          name: "OrderConfirm",
          params: { productId: key, month: 12 },
        });
      }
      let { href } = routerDate;
      window.open(href, "_blank");
    },
  },
};
</script>
<style scoped>
*{padding: 0;margin:0;}
body,button,input,select,textarea{font:12px/1.4 "Helvetica Neue", Helvetica, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", sans-serif;-webkit-font-smoothing: antialiased;}
h1,h2,h3,h4,h5,h6,b,strong{font-weight: normal;}
input:focus,button:focus{outline: 0;}
a{text-decoration: none;}
img{display: block;}
.flex {display:-ms-flexbox;display:-webkit-flex;display: flex;-webkit-flex-wrap:nowrap; -ms-flex-wrap:nowrap; flex-wrap:nowrap;}
[v-cloak]{display: none;}
.font-yellow{color: #FFE196!important;}
.font-org{color:#FFA647!important;}

.bg{background: #0C0F13 url('../../assets/images/activity/519celebrate/pc-bg-footer.jpg') no-repeat center bottom;position: relative;}
.bg:before,.bg:after{content:'';position: absolute;left: 50%;background: url('../../assets/images/activity/519celebrate/curve.png') no-repeat 0 0;width:1200px;height:1055px;margin-left: -600px;}
.bg:before{top:560px;}
.bg:after{top:2500px;-webkit-transform: scaleX(-1);-ms-transform: scaleX(-1);transform: scaleX(-1);}
.wrap2{max-width:1200px;margin: 0 auto;position:relative;z-index:1;}
.banner{position: relative;}
.btn-buy{position: absolute;;width: 254px;height:50px;top:220px;right:215px;text-indent: -999px;overflow: hidden;}
.mod{margin: 0 15px 70px;}
.mod-tit{margin-bottom:15px;text-indent:-999px;overflow: hidden;height: 55px;}
.tit-hdgz{background:url('../../assets/images/activity/519celebrate/title1.png') no-repeat 0 0;}
.tit-fldfs{background:url('../../assets/images/activity/519celebrate/title2.png') no-repeat 0 0;width:709px;}
.tit-yxds{background:url('../../assets/images/activity/519celebrate/title3.png') no-repeat 0 0;width:580px;}
.tit-pcdzh{background:url('../../assets/images/activity/519celebrate/title4.png') no-repeat 0 0;width:492px;}
.mod-block{background: rgba(33,39,54,0.80);border-radius:20px;padding:30px 46px 46px 38px;position:relative;}
.mod-block2{margin-top:90px;margin-bottom:80px;}
.mod-block p{font-size: 18px;color: #FFE9CD;text-align: justify;margin-top: 30px;}
.mod-block2 p{margin-top: 15px;}
.mod-block small{display: block;font-size:18px;color: #FFE9CD;opacity: 0.6;margin-top:20px;}
.mod-block img{margin:20px 0;}
.mod-block img:last-child{margin-bottom: 0;}
.block-tag{position: absolute;top:-28px;left: 0;line-height:56px;background-image: linear-gradient(90deg, #FFDAB2 0%, #FFAF6C 100%);background-image:-webkit-linear-gradient(left, #FFDAB2 0%, #FFAF6C 100%);padding: 0 20px;font-size:36px;color: #784516;border-radius: 30px 30px 30px 0;}
.date-tit{margin:50px 0 20px;color: #FFA647;font-weight: bold;font-size:40px;}
.date-tit >span{display: inline-block;padding:0 6px;line-height:46px;background:#FFA647;color: #fff;border-radius:8px;font-size: 30px;}
.date-tit > i{margin: 0 18px;}
.link-text{font-size:18px;color: #5BA2FF;margin-top:28px;display: block;text-decoration: underline;}
.symbol-list{overflow: hidden;padding-bottom: 5px;}
.symbol-list li{float: left;margin:25px 1% 0;width:23%;box-sizing:border-box;padding: 0 0 0 20px;position: relative;color: #FFD0A8;height: 115px;display: -webkit-flex; display: -ms-flexbox; display: flex; -webkit-align-items: center; -ms-flex-align: center; align-items: center;border:1px solid #826A55;border-radius:20px;}
.symbol-list li div:after{content:'';position:absolute;right:33px;top:50%;background: url('../../assets/images/activity/519celebrate/icons.png') no-repeat 0 0;width: 72px;height: 72px;margin-top: -29px;}
.symbol-list li.dsyp div:after{background-position:0 -144px;}
.symbol-list li.rdfx div:after{background-position:0 -72px;}
.symbol-list li.yxcl div:after{background-position:0 -216px;}
.symbol-list li.yxnc div:after{background-position:0 0;}
.symbol-list li p{font-weight: bold;margin-top: 0;font-size: 26px;}
.symbol-list li small{display: block;opacity: 0.6;font-size: 23px;margin-top: 4px;}

</style>


// WEBPACK FOOTER //
// src/pages/activity/celebrate519.vue